﻿document.addEventListener("alpine:init", () => {
    Alpine.data("videoPlayer", (autoplay = false, controls = false) => ({
        autoplay: autoplay,
        controls: controls,
        isPlaying: false,
        pauseTimeout: null,
        initialPlay: false,
        init() {
            this.video = this.$refs.video;
            if (autoplay) {
                this.video.play();
                this.isPlaying = true;
            }
        },
        togglePlayPause() {
            if (!this.video) return;

            if (this.video.paused) {
                this.video.play();
                this.isPlaying = true;
            } else {
                this.video.pause();
                this.isPlaying = false;
            }
        },
        togglePlay() {
            if (!this.video) return;

            if (this.initialPlay) return

            if (this.video.paused) {
                this.video.play();
                this.isPlaying = true;

                if (this.pauseTimeout) clearTimeout(this.pauseTimeout);

                this.pauseTimeout = setTimeout(() => {
                    this.$refs.video.setAttribute('controls', '');
                    this.initialPlay = true;
                }, 500);
            }
        }
    }));

    Alpine.data("limitToDigits", () => ({
        limitDigits(ev) {

            const input = ev.target;

            // Allow digits and spaces only
            input.value = input.value.replace(/[^0-9\s]/g, '');

            // Extract digits only
            const digits = input.value.replace(/\D/g, '');

            // Enforce max 8 digits
            if (digits.length > 8) {
                let count = 0;
                input.value = input.value.replace(/\d/g, () =>
                    count++ < 8 ? digits[count - 1] : ''
                );
            }
        }
    }))

});

window.onbeforeprint = () => {
    document.querySelectorAll('img[data-src]').forEach(img => {
        img.src = img.dataset.src; // force load
    });
};